import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function DenyRequest({denyModal, setDenyModal, handleShowDenyModal, denyId }) {
    const dispatch = useDispatch();
    const [reason, setReason] = useState('');

    const handleCloseModal = () => {
        setDenyModal(false);
        
    }

    const DENY = (denyId) => {
        handleCloseModal();
        const clientInfo = {
            request_id: denyId,
            reason: reason,
          }
          dispatch({ type: 'DENY_REQUEST', payload: clientInfo });

    }
      
    return (
        <Modal
            size="md"
            show={denyModal}
            onHide={() => handleCloseModal()}
            backdrop="static"
            id="denyModal"
        >
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">
                    <h1>Please Enter a Reason</h1>
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                    <Form.Control
                    as="textarea"
                    rows="3"
                    onChange={((e) => { setReason(e.target.value) })}
                    ></Form.Control>
                    <Row className="d-flex justify-content-around mt-3">
                    <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    >Close</Button><Button
                    onClick={() => DENY(denyId)}
                    >Save</Button>
                    </Row>
                    </Container>
                </Modal.Body>
        </Modal>

    );
}

export default DenyRequest;
